(function(){
const root=document.getElementById('wdr-puzzle');
if(!root)return;

const N=9;
const pieces=['R','J','V','B','P','A'];

const colors={
  R:'#e74c3c',
  J:'#f1c40f',
  V:'#2ecc71',
  B:'#3498db',
  P:'#9b59b6',
  A:'#ff66c4'
};

const names={
  R:'Rouge',
  J:'Jaune',
  V:'Vert',
  B:'Bleu',
  P:'Violet',
  A:'Rose'
};

const neigh=Array.from({length:9},(_,i)=>{
  let r=Math.floor(i/3);
  let c=i%3;
  let a=[];

  if(r)a.push(i-3);
  if(r<2)a.push(i+3);
  if(c)a.push(i-1);
  if(c<2)a.push(i+1);

  return a;
});

function key(s){
  return s.join('');
}

function moves(s){
  let out=[];

  for(let i=0;i<9;i++){
    if(s[i]==='.')continue;

    let empt=new Set();

    for(let j=0;j<9;j++){
      if(s[j]==='.'||j===i){
        empt.add(j);
      }
    }

    let seen=new Set([i]);
    let q=[i];

    while(q.length){
      let x=q.shift();

      for(let y of neigh[x]){
        if(empt.has(y)&&!seen.has(y)){
          seen.add(y);
          q.push(y);
        }
      }
    }

    for(let d of seen){
      if(d===i||s[d]!=='.')continue;

      let t=s.slice();

      t[d]=s[i];
      t[i]='.';

      out.push({
        state:t,
        from:i,
        to:d,
        piece:s[i]
      });
    }
  }

  return out;
}

function shortest(start,target,limit=12){
  let tk=key(target);
  let sk=key(start);

  if(sk===tk){
    return {
      dist:0,
      path:[]
    };
  }

  let q=[start];
  let head=0;

  let prev=new Map([[sk,null]]);
  let depth=new Map([[sk,0]]);
  let pm=new Map();

  while(head<q.length){
    let s=q[head++];
    let kk=key(s);
    let d=depth.get(kk);

    if(d>=limit)continue;

    for(let m of moves(s)){
      let k=key(m.state);

      if(prev.has(k))continue;

      prev.set(k,kk);
      depth.set(k,d+1);
      pm.set(k,m);

      if(k===tk){
        let path=[];
        let cur=k;

        while(prev.get(cur)){
          path.push(pm.get(cur));
          cur=prev.get(cur);
        }

        path.reverse();

        return {
          dist:path.length,
          path:path
        };
      }

      q.push(m.state);
    }
  }

  return null;
}

function randState(){
  let a=pieces.concat(['.','.','.']);

  for(let i=a.length-1;i>0;i--){
    let j=Math.floor(Math.random()*(i+1));

    [a[i],a[j]]=[a[j],a[i]];
  }

  return a;
}

function transientCount(path,target){
  let targetPos={};

  target.forEach((x,i)=>{
    if(x!=='.'){
      targetPos[x]=i;
    }
  });

  return path.filter(
    m=>m.to!==targetPos[m.piece]
  ).length;
}

function repeatPieces(path){
  let c={};

  path.forEach(m=>{
    c[m.piece]=(c[m.piece]||0)+1;
  });

  return Object.values(c)
    .filter(x=>x>1)
    .length;
}

function fits(level,d,t,r){

  if(level==1){
    return d>=1&&d<=3&&t===0;
  }

  if(level==2){
    return d>=3&&d<=5&&t<=1;
  }

  if(level==3){
    return d>=5&&d<=7&&t>=1;
  }

  if(level==4){
    return d>=7&&d<=9&&t>=2&&r>=2;
  }

  if(level==5){
    return d>=9&&d<=11&&t>=3&&r>=3;
  }

  if(level==6){
    return d>=11&&d<=12&&t>=4&&r>=4;
  }

  return false;
}

function distanceMap(target,maxDepth){
  const tk=key(target);

  const dist=new Map([
    [tk,0]
  ]);

  const q=[target];
  let head=0;

  while(head<q.length){
    const s=q[head++];
    const sk=key(s);
    const d=dist.get(sk);

    if(d>=maxDepth)continue;

    for(const m of moves(s)){
      const k=key(m.state);

      if(dist.has(k))continue;

      dist.set(k,d+1);
      q.push(m.state);
    }
  }

  return dist;
}
function optimalPathFromMap(start,target,dist){

  let state=start.slice();
  let path=[];

  while(key(state)!==key(target)){

    const currentDist=dist.get(key(state));

    const candidates=moves(state).filter(
      m=>dist.get(key(m.state))===currentDist-1
    );

    if(!candidates.length){
      return null;
    }

    /*
      On choisit au hasard parmi les mouvements
      restant sur une solution optimale.
    */
    const chosen=
      candidates[
        Math.floor(
          Math.random()*candidates.length
        )
      ];

    path.push(chosen);
    state=chosen.state.slice();
  }

  return path;
}
async function generateExpertCard(level,n){

  /*
    On essaie plusieurs configurations d'arrivée,
    mais chaque arrivée ne nécessite qu'un seul BFS.
  */
  for(let attempt=0;attempt<40;attempt++){

    const target=randState();

    /*
      On calcule tous les états jusqu'à distance 12.
    */
    const dist=distanceMap(
      target,
      12
    );

    /*
      On récupère directement les configurations
      situées à 11 ou 12 mouvements.
    */
    let expertStates=[];

    for(const [stateKey,d] of dist.entries()){

      if(d===11||d===12){

        expertStates.push(
          stateKey.split('')
        );
      }
    }

    /*
      Mélange des candidats
    */
    for(
      let i=expertStates.length-1;
      i>0;
      i--
    ){

      const j=
        Math.floor(
          Math.random()*(i+1)
        );

      [
        expertStates[i],
        expertStates[j]
      ]=[
        expertStates[j],
        expertStates[i]
      ];
    }

    /*
      On teste uniquement les configurations
      déjà garanties à 11–12 mouvements.
    */
    for(
      let i=0;
      i<expertStates.length;
      i++
    ){

      const start=
        expertStates[i];

      const path=
        optimalPathFromMap(
          start,
          target,
          dist
        );

      if(!path)continue;

      const res={
        dist:path.length,
        path:path
      };

      const tr=
        transientCount(
          path,
          target
        );

      const rp=
        repeatPieces(
          path
        );

      /*
        Nos critères actuels du niveau expert.
      */
      if(
        res.dist>=11
        &&
        res.dist<=12
        &&
        tr>=4
        &&
        rp>=4
      ){

        return card(
          start,
          target,
          res,
          level,
          n
        );
      }

      /*
        Évite de bloquer le navigateur
        si beaucoup de candidats sont examinés.
      */
      if(i%100===0){

        await new Promise(
          r=>setTimeout(r,0)
        );
      }
    }
  }

  return null;
}
function strategicAnalysis(start,target,res){

  const dist=distanceMap(
    target,
    res.dist
  );

  const targetPos={};

  target.forEach((x,i)=>{
    if(x!=='.'){
      targetPos[x]=i;
    }
  });

  let state=start.slice();

  let forcedSteps=0;
  let trapSteps=0;
  let falseMoves=0;

  let optimalChoices=[];

  for(let step=0;step<res.dist;step++){

    const remaining=res.dist-step;

    const legal=moves(state);

    const optimal=legal.filter(
      m=>dist.get(key(m.state))===remaining-1
    );

    optimalChoices.push(optimal.length);

    if(optimal.length===1){
      forcedSteps++;
    }

    let trapsHere=0;

    for(const m of legal){

      if(targetPos[m.piece]!==m.to){
        continue;
      }

      if(
        dist.get(
          key(m.state)
        )!==remaining-1
      ){
        trapsHere++;
        falseMoves++;
      }
    }

    if(trapsHere>0){
      trapSteps++;
    }

    const chosen=res.path[step];

    state=chosen.state.slice();
  }

  return {
    forcedSteps:forcedSteps,
    forcedRatio:res.dist
      ? forcedSteps/res.dist
      : 0,
    trapSteps:trapSteps,
    falseMoves:falseMoves,
    optimalChoices:optimalChoices
  };
}

function pos(i){
  return 'ABC'[Math.floor(i/3)]
    +(i%3+1);
}

/*
  AFFICHAGE V1 CONSERVÉ
*/
function board(s){
  return `
    <div class="board">
      ${
        s.map(x=>`
          <div class="cell">
            ${
              x==='.'
              ? ''
              : `
                <div
                  class="wdr-puzzle-token"
                  style="
                    width:46px;
                    height:46px;
                    min-width:46px;
                    min-height:46px;
                    display:block;
                    border-radius:50%;
                    background-color:${colors[x]} !important;
                    border:2px solid rgba(0,0,0,0.12);
                    box-sizing:border-box;
                  "
                ></div>
              `
            }
          </div>
        `).join('')
      }
    </div>
  `;
}

function constraintLabel(a,res){

  if(res.dist<=1){
    return 'faible';
  }

  if(a.forcedRatio>=0.70){
    return 'fort';
  }

  if(a.forcedRatio>=0.40){
    return 'moyen';
  }

  return 'faible';
}

function card(start,target,res,level,n){

  let t=transientCount(
    res.path,
    target
  );

  let r=repeatPieces(
    res.path
  );

  let a=strategicAnalysis(
    start,
    target,
    res
  );

  let constraint=
    constraintLabel(
      a,
      res
    );

  return `
    <div class="panel">

      <h2>
        Niveau ${level} — fiche ${n}
      </h2>

      <div class="boards">

        <div>
          <b>Départ</b>
          ${board(start)}
        </div>

        <div class="arrow">
          →
        </div>

        <div>
          <b>Arrivée</b>
          ${board(target)}
        </div>

      </div>

      <div class="meta">

        <span class="tag">
          Minimum : ${res.dist} mouvements
        </span>

        <span class="tag">
          Transitoires : ${t}
        </span>

        <span class="tag">
          Pions répétés : ${r}
        </span>

        <span class="tag">
          Pièges intuitifs : ${a.trapSteps}
        </span>

        <span class="tag">
          Ordre contraint : ${constraint}
          (${a.forcedSteps}/${res.dist})
        </span>

      </div>

      <details>

        <summary>
          Afficher une solution optimale
        </summary>

        <ol class="solution">

          ${
            res.path.map(
              (m,i)=>`
                <li>
                  ${names[m.piece]} :
                  ${pos(m.from)}
                  →
                  ${pos(m.to)}
                  ${
                    a.optimalChoices[i]===1
                    ? ' <strong>• étape forcée</strong>'
                    : ''
                  }
                </li>
              `
            ).join('')
          }

        </ol>

        <p class="small">
          <strong>Pièges intuitifs :</strong>
          étapes où un pion peut rejoindre immédiatement
          sa position finale mais où ce choix fait perdre
          la solution minimale.
          <br><br>
          <strong>Ordre contraint :</strong>
          nombre d’étapes où un seul déplacement
          permet de rester sur une solution optimale.
        </p>

      </details>

    </div>
  `;
}

async function generate(){

  let level=
    +root.querySelector('#level').value;

  let count=
    Math.min(
      20,
      +root.querySelector('#count').value||1
    );

  let out=
    root.querySelector('#out');

  out.innerHTML=
    '<div class="panel">Recherche de problèmes vérifiés…</div>';

  await new Promise(
    r=>setTimeout(r,30)
  );

  let cards=[];
let seen=new Set();
let tries=0;

/*
  NIVEAU 6 :
  génération ciblée beaucoup plus rapide.
*/
if(level===6){

  for(
    let n=1;
    n<=count;
    n++
  ){

    out.innerHTML=
      `
        <div class="panel">
          Génération expert :
          fiche ${n}/${count}…
        </div>
      `;

    await new Promise(
      r=>setTimeout(r,20)
    );

    const expertCard=
      await generateExpertCard(
        level,
        n
      );

    if(expertCard){

      cards.push(
        expertCard
      );

    }else{

      break;
    }
  }

}else{

  /*
    NIVEAUX 1 À 5 :
    on conserve exactement
    notre méthode actuelle.
  */
  while(
    cards.length<count
    &&
    tries<15000
  ){

    tries++;

    let s=randState();
    let t=randState();

    let pair=
      key(s)+'>'+key(t);

    if(seen.has(pair)){
      continue;
    }

    seen.add(pair);

    let res=
      shortest(
        s,
        t,
        12
      );

    if(!res){
      continue;
    }

    let tr=
      transientCount(
        res.path,
        t
      );

    let rp=
      repeatPieces(
        res.path
      );

    if(
      fits(
        level,
        res.dist,
        tr,
        rp
      )
    ){

      cards.push(
        card(
          s,
          t,
          res,
          level,
          cards.length+1
        )
      );
    }

    if(tries%100===0){

      await new Promise(
        r=>setTimeout(r,0)
      );
    }
  }
}

  out.innerHTML=
    cards.join('')
    +
    (
      cards.length<count
      ? `
        <div class="panel err">
          Seulement ${cards.length} fiche(s)
          trouvée(s) après ${tries} essais.
          Relancez la génération.
        </div>
      `
      : ''
    );
}

root.querySelector('#gen').onclick=generate;

const printButton=
  root.querySelector('#wdr-print');

if(printButton){
  printButton.onclick=
    ()=>window.print();
}

generate();

})();